import { render } from "./BaseButton.vue?vue&type=template&id=70e9b42e&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=70e9b42e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70e9b42e"

export default script